"use client";

import { c as _c } from "react/compiler-runtime";
import type { PortableTextBlock } from "@portabletext/types";
import { PortableTextBody } from "@/components/PortableTextBody";
type Props = {
  value: PortableTextBlock[];
};
export function LocationContentBody(t0) {
  const $ = _c(2);
  const {
    value
  } = t0;
  let t1;
  if ($[0] !== value) {
    t1 = <PortableTextBody value={value} paragraphClassName="text-base" />;
    $[0] = value;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}